import { render } from "@/components/pages/individualWorkSupport/requirement137/Requirement137.html?vue&type=template&id=3ae8fd04&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement137/Requirement137.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement137/Requirement137.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement137/Requirement137.scss?vue&type=style&index=0&id=3ae8fd04&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae8fd04"]])

export default __exports__